import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

import "./styles/_image-caption.scss"

export interface ImageCaptionProps extends WithClassName {
  children: React.ReactNode
  caption: string | null
  isLoading?: boolean
}

export const ImageCaption = React.memo(
  ({ children, caption, className, isLoading }: ImageCaptionProps) => {
    return (
      <figure
        className={classNames(
          "image-caption",
          { "image-caption--loading": isLoading },
          className
        )}
      >
        <div className="image-caption__image">{children}</div>
        {caption ? (
          <figcaption className="image-caption__caption">{caption}</figcaption>
        ) : null}
      </figure>
    )
  }
)
